import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { removeInspectorEvent, selectInspectorEvents } from "src/slices/gameEvents.slice";
import Button from "src/components/ui/Button";
import { BOX_SHADOW } from "src/vars";

const OpenExternalLinkModalWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(0 0 0 / 20%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
`;

const OpenExternalLinkModalContent = styled.div`
    background: var(--surface);
    padding: 16px;
    border-radius: 8px;
    box-shadow: ${BOX_SHADOW}
`;

const OpenExternalLinkModalButtons = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    margin-top: 16px;
`;

export default function OpenExternalLinkModal() {
    const dispatch = useDispatch();

    const inspectorEvents = useSelector(selectInspectorEvents);

    const openExternalLinkEvent = inspectorEvents.find(event => event.event === 'open-external-link');

    const handleBackToGame = () => {
        // clear the open-external-link event from the inspector events
        dispatch(removeInspectorEvent({ event: 'open-external-link' }));
    }

    const handleContinueToSite = () => {
        const { data: { params: { url } } } = openExternalLinkEvent;

        window.open(url, '_blank', 'noopener');
        dispatch(removeInspectorEvent({ event: 'open-external-link' }));
    }

    if (openExternalLinkEvent) {
        return (
            <OpenExternalLinkModalWrapper>
                <OpenExternalLinkModalContent>
                    <h2>Heads Up!</h2>
                    <p>You’re about to leave Poki and go to another site we don’t control.</p>
                    <OpenExternalLinkModalButtons>
                        <Button onClick={handleContinueToSite}>Continue to site</Button>
                        <Button isPrimary onClick={handleBackToGame}>Back to game</Button>
                    </OpenExternalLinkModalButtons>
                </OpenExternalLinkModalContent>
            </OpenExternalLinkModalWrapper>
        );
    }

    return null;
}
